module.exports = __webpack_public_path__ + "0108c187afe9f1c87a43097be92abd41.png";